export const getResources = async ({ queryKey }) => {
  const [_key] = queryKey;
  let data = await fetch(`${process.env.API_URL}/resources`).then((r) => r.json());
  return data.data;
};

export const addResource = async ({ data, token }) => {
  let newEntry = await fetch(`${process.env.API_URL}/resources`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  }).then((r) => r.json());
  return newEntry.data;
};

export const deleteResource = async ({ data, token }) => {
  let deletedEntry = await fetch(`${process.env.API_URL}/resources/delete`, {
    method: 'DELETE',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  }).then((r) => r.json());
  return deletedEntry.data;
};
